/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserAccountDto } from './userAccountDto';

/**
 * Current user.
 */
export interface UserDto {
  login: string;
  role: UserDto.RoleEnum;
  enabled2FA: boolean;
  forceToResetPassword: boolean;
  canTrade: boolean;
  subRole: UserDto.SubRoleEnum;
  firstName?: string;
  lastName?: string;
  accountType: UserDto.AccountTypeEnum;
  accountStatus?: UserDto.AccountStatusEnum;
  accountName: string;
  lastPasswordChangeTime: string;
  /**
   * True if the user signs in with google single sign-on only.
   */
  ssoOnly: boolean;
  /**
   * Main account and subaccounts visible to the user. Main account goes first if visible.
   */
  accounts: Array<UserAccountDto>;
}
export namespace UserDto {
  export const RoleEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    ClientApiKey: 'CLIENT_API_KEY',
    AdminRead: 'ADMIN_READ',
    SuperAdmin: 'SUPER_ADMIN',
    AdminCompliance: 'ADMIN_COMPLIANCE',
  } as const;
  export type RoleEnum = (typeof RoleEnum)[keyof typeof RoleEnum];
  export const SubRoleEnum = {
    ReadOnly: 'READ_ONLY',
    Trader: 'TRADER',
    TraderPro: 'TRADER_PRO',
  } as const;
  export type SubRoleEnum = (typeof SubRoleEnum)[keyof typeof SubRoleEnum];
  export const AccountTypeEnum = {
    Company: 'COMPANY',
    Individual: 'INDIVIDUAL',
  } as const;
  export type AccountTypeEnum = (typeof AccountTypeEnum)[keyof typeof AccountTypeEnum];
  export const AccountStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Paused: 'PAUSED',
  } as const;
  export type AccountStatusEnum =
    (typeof AccountStatusEnum)[keyof typeof AccountStatusEnum];
}
